<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-4">
        <div
          class="col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">Photos for Experiences</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 alinmov3">
          <div class="box-buttons">
            <base-button type="primary" @click="uploadFile" class="min-button">
              <i class="flaticon-arrow-up"></i> Upload
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mb-5 forms">
      <div class="col-12">
        <div class="row">
          <div class="col-xl-3 col-lg-4 col-md-12">
            <div class="card">
              <div class="row">
                <div class="col-12 col-lg-12 col-md-8">
                  <h3 class="subtitle mb-4">
                    Select Vehicle
                  </h3>
                  <div class="row">
                    <div class="col-12 col-lg-12 col-md-4 col-sm-6">
                      <WSelect
                        v-bind:class="{
                          'is-invalid': $v.vehicle.parameters.type.$error
                        }"
                        placeholder="Type"
                        v-model="vehicle.parameters.type"
                        filterable
                        label="Vehicle Type"
                        @change="selectVehicleType"
                        :error="
                          $v.vehicle.parameters.type.$error
                            ? `Select vehicle Type`
                            : ''
                        "
                      >
                        <el-option
                          v-for="typev in vehicleTypes"
                          :value="typev.value"
                          :label="typev.label"
                          :key="typev.label"
                        ></el-option>
                      </WSelect>
                    </div>

                    <div class="col-12 col-lg-12 col-md-4 col-sm-6">
                      <WSelect
                        v-bind:class="{
                          'is-invalid': $v.vehicle.parameters.make.$error
                        }"
                        placeholder="Make"
                        v-model="vehicle.parameters.make"
                        @change="selectVehicleMake"
                        filterable
                        label="Make"
                        :error="
                          $v.vehicle.parameters.make.$error ? `Select Make` : ''
                        "
                      >
                        <el-option
                          v-for="options in makes"
                          :value="options.value"
                          :label="options.label"
                          :key="options.label"
                        ></el-option>
                      </WSelect>
                    </div>

                    <div class="col-12 col-lg-12 col-md-4 col-sm-6">
                      <WSelect
                        v-bind:class="{
                          'is-invalid': $v.vehicle.parameters.model.$error
                        }"
                        placeholder="Model"
                        v-model="vehicle.parameters.model"
                        @change="selectVehicleModel"
                        filterable
                        label="Model"
                        :error="
                          $v.vehicle.parameters.model.$error
                            ? `Select Model`
                            : ''
                        "
                      >
                        <el-option
                          v-for="(options, index) in models"
                          :value="options.value"
                          :label="options.label"
                          :key="index"
                        ></el-option>
                      </WSelect>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-12 col-md-4 col-sm-12">
                  <div class="col-12 col-lg-12 col-md-12 col-sm-6 ">
                    <h3 class="subtitle">Rate Image</h3>
                    <div class="text-center">
                      <img
                        :src="vehicle.parameters.image"
                        class="img-fluid-2 mb-4"
                        alt="imgvehicle"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-9 col-lg-8 col-md-12" v-if="images.length > 0">
            <div class="card p-card">
              <div class="row justify-content-center">
                <div
                  class="image-media"
                  v-for="(item, index) in images"
                  :key="index"
                >
                  <div v-if="item.type === 'File'">
                    <div class="image-wrapper">
                      <div class="image-overlay"></div>
                      <img
                        v-lazy="item.fileUrl"
                        :alt="showName(item.filePath)"
                        class="preview-image"
                      />
                      <span class="file-name-two">
                        {{ showName(item.filePath) }}
                      </span>
                      <span class="file-size mb-2">
                        {{ showSize(item.size) }}
                      </span>

                      <base-button
                        class="delete-button"
                        @click.stop="
                          deleteImagesByFilePath(item.filePath, item.fileUrl)
                        "
                      >
                        <i class="flaticon-delete"></i>
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-9 col-lg-8 col-md-12" v-else>
            <base-alert type="secondary" class="alert-box">
              <h4><strong>There are no images here!</strong></h4>

              Upload images for the product gallery

              <img
                src="~rhomtrip_assets/src/img/character/waiting.png"
                alt="RhomTrip Timer"
                class="character"
              />
            </base-alert>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import { BytescaleAPI, VehiclesAPI } from "../../../../../core/api";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
import { goBack } from "../../../../../helpers/commons.helpers";
import {
  BYTESCALE_API_PUBLIC_KEY,
  IMAGE_BASE_URL
} from "../../../../../core/config/env";

const uploader = Uploader({
  apiKey: BYTESCALE_API_PUBLIC_KEY
});

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "Media",
  data() {
    return {
      makes: [],
      models: [],
      vehicle: {
        parameters: {
          type: "",
          make: "",
          model: "",
          category: "",
          name: "",
          type_category: "",
          image: require("rhomtrip_assets/src/img/no-preview-car.jpg")
        }
      },
      vehicleTypes: [
        { label: "Boats", value: "boat" },
        { label: "Coach", value: "coach" },
        { label: "Limousine", value: "limousine" },
        { label: "Minibus", value: "minibus" },
        { label: "MidiCoach", value: "midicoach" },
        { label: "Minivan", value: "minivan" },
        { label: "MPV", value: "mpv" },
        { label: "Pickup", value: "pickup" },
        { label: "Premium Sedans", value: "premium_sedans" },
        { label: "SUVs", value: "suvs" },
        { label: "Sedan", value: "sedan" }
      ],
      images: [],
      carsOptions: [],
      carId: null
    };
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Vehicles",
        to: "/vehicles"
      },

      {
        text: "Gallery",
        to: "/tools/vehicles-gallery"
      },
      {
        text: "New Photos",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.carsOptions = await this.getCarsOptions();
  },
  methods: {
    showDeleteButton(index) {
      this.$set(this.showDeleteButtons, index, true);
    },
    hideDeleteButton(index) {
      this.$set(this.showDeleteButtons, index, false);
    },
    showName(patch) {
      return patch.split("/").pop();
    },
    showSize(size) {
      let bytes = size;
      let result = "";
      if (bytes < 1024) {
        result = `${bytes} Bytes`;
      } else if (bytes < 1024 * 1024) {
        result = `${(bytes / 1024).toFixed(2)} KB`;
      } else if (bytes < 1024 * 1024 * 1024) {
        result = `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
      } else {
        result = `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
      }
      return result;
    },
    crumbs(patch) {
      let crumbs = [];
      let routeSegments = patch.split("/").filter(segment => segment !== "");
      let currentPath = "";
      for (let segment of routeSegments) {
        currentPath += `/${segment}`;
        crumbs.push({ label: segment, to: currentPath });
      }
      return crumbs;
    },

    selectVehicleType(type) {
      this.vehicle.parameters.make = "";
      this.vehicle.parameters.name = "";
      this.vehicle.parameters.model = "";
      this.vehicle.parameters.image = this.vehicle.parameters.image = require("rhomtrip_assets/src/img/no-preview-car.jpg");
      let types = this.carsOptions.filter(element => element.type === type);
      this.makes = this.getMakes(types);
    },
    selectVehicleMake(make) {
      if (make) {
        let name = this.carsOptions.find(element => element.make === make);
        this.vehicle.parameters.name = name.make_label;
        this.make_label = this.vehicle.parameters.name;
        this.vehicle.parameters.make = make;
        this.vehicle.parameters.model = "";
        this.models = this.getModels(make);
      } else {
        this.vehicle.parameters.model = "";
        this.models = [];
      }
    },
    async selectVehicleModel(vehicleModel) {
      let model = this.models.find(element => element.value === vehicleModel);
      if (model) {
        this.model = model;
        this.vehicle.parameters.model = model.value;
        this.vehicle.parameters.name = `${this.make_label} ${model.label}`;
        this.vehicle.parameters.image = `${IMAGE_BASE_URL}/vehicles/${model.ref}.png`;
        this.carId = model.carId;
        this.images = await this.getFilesByPatch(
          `/vehicles/gallery/${this.vehicle.parameters.type}/${this.vehicle.parameters.make}/${this.vehicle.parameters.model}`
        );
      }
    },
    getMakes(types) {
      return types
        .filter((value, index, self) => {
          return self.map(e => e.make).indexOf(value.make) === index;
        })
        .map(element => {
          return {
            label: element.make_label,
            value: element.make,
            type: element.type
          };
        })
        .sort(this.sortAscending);
    },
    getModels(make) {
      return this.carsOptions
        .filter((element, index, self) => {
          return (
            element.make === make &&
            element.type === this.vehicle.parameters.type
          );
        })
        .map(element => {
          return {
            carId: element._id,
            label: element.model_label,
            value: element.model,
            type: element.type,
            make: element.make,
            ref: element.slug
          };
        })
        .sort(this.sortAscending);
    },
    async getFilesByPatch(folderPath) {
      try {
        this.setLoad(true);
        let { data } = await BytescaleAPI.getFilesByFilePath(folderPath);
        this.setLoad(false);
        if (data) {
          return data.items;
        } else {
          return [];
        }
      } catch (error) {
        this.setLoad(false);
        return [];
      }
    },
    getPaths(vehicle) {
      return {
        folderPath: `/vehicles/gallery/${vehicle.parameters.type}/${vehicle.parameters.make}/${vehicle.parameters.model}`,
        fileName: `${vehicle.parameters.make}-${vehicle.parameters.type}-${vehicle.parameters.model}`
      };
    },
    goToPreviousPage() {
      goBack(this);
    },
    async showUploader(images = [], folderPath, fileName, vehicle) {
      try {
        let files = await this.uploaderOpen(
          10 - images.length,
          folderPath,
          fileName,
          vehicle
        );
        if (files) {
          this.images = await this.getFilesByPatch(folderPath);
          await this.updatedCar(
            this.carId,
            this.images.map(item => item.fileUrl),
            "The image has been saved successfully"
          );
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async uploadFile() {
      if (!this.$v.vehicle.$invalid) {
        let { folderPath, fileName } = this.getPaths(this.vehicle);
        if (this.images.length < 10) {
          await this.showUploader(
            this.images,
            folderPath,
            fileName,
            this.vehicle
          );
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "No more than 10 images allowed",
            icon: "flaticon-warning-1"
          });
        }
      } else {
        this.$v.vehicle.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Enter Vehicle info to upload images",
          icon: "flaticon-warning-1"
        });
      }
    },
    async uploaderOpen(maxFileCount, folderPath, fileName, metadata) {
      return await uploader.open({
        maxFileCount: maxFileCount,
        maxFileSizeBytes: 1048576, //1MB
        mimeTypes: ["image/jpeg", "image/png"],
        multi: true,
        styles: {
          colors: {
            active: "#528fff",
            error: "#d23f4d",
            primary: "#4b56a6"
          }
        },
        editor: {
          images: {
            crop: false,
            preview: false
          }
        },
        originalFileName: `${fileName}-{UNIQUE_DIGITS_4}{ORIGINAL_FILE_EXT}`,
        path: {
          folderPath: folderPath,
          folderPathVariablesEnabled: true,
          fileName: `${fileName}-{UNIQUE_DIGITS_4}{ORIGINAL_FILE_EXT}`,
          fileNameVariablesEnabled: true
        },
        metadata: {
          vehicleName: metadata.parameters.name,
          vehicleParams: {
            make: metadata.parameters.make,
            model: metadata.parameters.model,
            type: metadata.parameters.type
          }
        }
      });
    },
    async deleteImagesByFilePath(filePath, fileUrl) {
      let { value } = await Swal.fire({
        title: "Delete Images",
        text: "Are you sure do you want delete this images?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",
        confirmButtonClass: "btn btn-primary btn-small-one"
      });
      if (value) {
        await this.deleteFileByFilePath(filePath, fileUrl);
      }
    },
    async deleteFileByFilePath(filePath, fileUrl) {
      try {
        let isImageInUse = await this.verifyImageUsage([fileUrl]);
        if (!isImageInUse) {
          let { data } = await BytescaleAPI.deleteFileByFilePath(filePath);
          this.images = await this.getFilesByPatch(
            `/vehicles/gallery/${this.vehicle.parameters.type}/${this.vehicle.parameters.make}/${this.vehicle.parameters.model}`
          );
          await this.updatedCar(
            this.carId,
            this.images.map(item => item.fileUrl),
            "The image has been deleted successfully"
          );
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message:
              "The image can not be deleted because it is being used in some experience",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async getCarsOptions() {
      try {
        let { data } = await VehiclesAPI.getCarsOptions(this.sesion.token);
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    async updatedCar(carId, pictures = [], message) {
      let isUpdated = await this.updateCarById(carId, { pictures: pictures });
      if (isUpdated) {
        this.$notify({
          type: "success",
          title: "Success!",
          message: message,
          icon: "flaticon-check-3"
        });
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async updateCarById(carId, car) {
      try {
        let { data } = await VehiclesAPI.updateCarById(
          carId,
          car,
          this.sesion.token
        );
        if (data.status) {
          return data.data.updated;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    async verifyImageUsage(images = []) {
      try {
        let { data } = await VehiclesAPI.verifyImageUsage(
          images,
          this.sesion.token
        );
        if (data.status) {
          return data.data.isImageInUse;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    isInVehicleGalleryModule(modules = []) {
      if (!(modules.indexOf("vehicles-gallery") > -1)) {
        this.setCarSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    ...mapMutations(["setLoad", "setItemsBread", "setCarSearchCriteria"]),
    ...mapActions([])
  },
  computed: {
    ...mapGetters(["sesion", "sigout"])
  },
  components: {
    WSelect
  },
  validations: {
    vehicle: {
      parameters: {
        type: {
          required
        },
        make: {
          required
        },
        model: {
          required
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInVehicleGalleryModule(to.meta.modules);
    next();
  }
};
</script>
